module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_3_2.9d1f1595.jpeg";